import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-default-footer',
    templateUrl: './default-footer.component.html',
    styleUrls: ['./default-footer.component.scss'],
    standalone: false
})
export class DefaultFooterComponent implements OnInit {

  copyright: string;

  ngOnInit(): void {
    this.copyright = `${(new Date()).getFullYear()} Chevron Corporation`;
  }
}
